module.exports = __webpack_public_path__ + "static/media/dashbord_icon.8b162407.svg";